/* Cotton Linen UI · carousels + dots, tabs, quick add, toast, swipe deck. Safe to load many times. */
(function(){
  if (window.__clUI) return; window.__clUI = 1;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  function toast(msg, bag){
    var t = document.querySelector('.cl-toast');
    if (!t){ t = document.createElement('div'); t.className = 'cl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = esc(msg) + (bag ? '<a href="' + R + 'cart">View bag</a>' : '');
    t.classList.add('is-on'); clearTimeout(t._h); t._h = setTimeout(function(){ t.classList.remove('is-on'); }, 2800);
  }
  window.clToast = toast;

  function add(id){
    return fetch(R + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items:[{ id:id, quantity:1 }] }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function(){ return fetch(R + 'cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        document.querySelectorAll('[data-cl-count]').forEach(function(el){ el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles:true, detail:{ resource:cart, sourceId:'cl-quick-add', data:{ itemCount:cart.item_count, source:'cl-quick-add' } } }));
        toast('Added to bag', true);
      })
      .catch(function(e){ toast(e.message); });
  }

  var sheet;
  function qa(el){
    var vs = []; try { vs = JSON.parse(el.getAttribute('data-variants') || '[]'); } catch(e){}
    if (!vs.length) return;
    if (vs.length === 1){ if (vs[0].a) add(vs[0].id); else toast('Sold out'); return; }
    if (!sheet){
      sheet = document.createElement('dialog'); sheet.className = 'cl-qa'; document.body.appendChild(sheet);
      sheet.addEventListener('click', function(e){
        if (e.target === sheet || e.target.closest('[data-x]')){ sheet.close(); return; }
        var s = e.target.closest('[data-id]');
        if (s && !s.disabled){ sheet.close(); add(+s.getAttribute('data-id')); }
      });
    }
    var img = el.getAttribute('data-img'), t = el.getAttribute('data-title');
    sheet.innerHTML = '<div class="cl-qa__in"><div class="cl-qa__hd">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') +
      '<div class="cl-qa__ti"><p class="cl-qa__t">' + esc(t) + '</p><p class="cl-qa__s">Select your size</p></div>' +
      '<button type="button" class="cl-qa__x" data-x aria-label="Close">&times;</button></div><div class="cl-qa__sz">' +
      vs.map(function(v){ return '<button type="button" data-id="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>'; }).join('') + '</div></div>';
    if (sheet.showModal) sheet.showModal();
  }
  window.clQA = qa;
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-cl-qa]');
    if (b){ e.preventDefault(); e.stopPropagation(); qa(b); }
  });

  function setup(tr){
    if (tr._cl){ tr._cl.build(); return; }
    var d = tr.nextElementSibling; if (!d || !d.hasAttribute('data-cl-dots')) d = null;
    var o = {}; tr._cl = o;
    function pages(){ var w = tr.clientWidth; if (!w) return 0; return Math.ceil((tr.scrollWidth - w) / w - 0.03) + 1; }
    function idx(){ var w = tr.clientWidth || 1, max = tr.scrollWidth - w; if (tr.scrollLeft >= max - 4) return pages() - 1; return Math.round(tr.scrollLeft / w); }
    function go(i){ var w = tr.clientWidth, max = tr.scrollWidth - w; tr.scrollTo({ left: Math.min(i * w, max), behavior:'smooth' }); }
    o.upd = function(){ if (!d) return; var k = idx(); [].forEach.call(d.children, function(c, j){ c.classList.toggle('is-on', j === k); }); };
    o.build = function(){
      if (!d) return;
      var n = pages(); d.innerHTML = ''; d.hidden = n < 2;
      for (var i = 0; i < n; i++){ (function(i){ var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1)); b.onclick = function(){ go(i); }; d.appendChild(b); })(i); }
      o.upd();
    };
    tr.addEventListener('scroll', function(){ cancelAnimationFrame(o.r); o.r = requestAnimationFrame(o.upd); }, { passive:true });
    var a = parseFloat(tr.getAttribute('data-cl-auto') || '0');
    if (a > 0){
      var paused = false, rt;
      tr.addEventListener('pointerdown', function(){ paused = true; clearTimeout(rt); rt = setTimeout(function(){ paused = false; }, 8000); });
      tr.addEventListener('mouseenter', function(){ paused = true; });
      tr.addEventListener('mouseleave', function(){ paused = false; });
      setInterval(function(){ if (paused || document.hidden || !tr.isConnected) return; var n = pages(), k = idx(); go(k + 1 >= n ? 0 : k + 1); }, a * 1000);
    }
    o.build();
  }
  window.clCarousel = setup;

  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cl-tab]'); if (!t) return;
    var w = t.closest('[data-cl-tabs]'); if (!w) return;
    var k = t.getAttribute('data-cl-tab');
    w.querySelectorAll('[data-cl-tab]').forEach(function(b){ var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
    w.querySelectorAll('[data-cl-panel]').forEach(function(p){
      p.hidden = p.getAttribute('data-cl-panel') !== k;
      if (!p.hidden){ var tr = p.querySelector('[data-cl-track]'); if (tr){ tr.scrollLeft = 0; setup(tr); } }
    });
  });

  function swipe(w){
    if (w._cl) return; w._cl = 1;
    var cards = [].slice.call(w.querySelectorAll('[data-sw-card]')), bars = w.querySelectorAll('[data-sw-bar]'), i = 0, hist = [];
    function lay(){
      cards.forEach(function(c, k){
        var d = k - i;
        if (d < 0){ c.style.pointerEvents = 'none'; return; }
        c.style.transition = 'transform .3s ease, opacity .3s ease';
        c.style.pointerEvents = d === 0 ? 'auto' : 'none';
        c.style.zIndex = 50 - d;
        c.style.opacity = d > 2 ? '0' : '1';
        c.style.transform = d === 0 ? 'none' : 'translateY(' + (Math.min(d, 2) * 12) + 'px) scale(' + (1 - Math.min(d, 2) * 0.05) + ')';
      });
      bars.forEach(function(b, k){ b.classList.toggle('is-on', k <= i); });
      w.classList.toggle('is-done', i >= cards.length);
    }
    function like(c){
      try { var l = JSON.parse(localStorage.getItem('clLikes') || '[]'), h = c.getAttribute('data-handle'); if (l.indexOf(h) < 0) l.push(h); localStorage.setItem('clLikes', JSON.stringify(l)); } catch(e){}
      toast('Saved to your likes \u2665');
    }
    function out(dir){
      var c = cards[i]; if (!c) return;
      c.style.transition = 'transform .35s ease, opacity .35s ease';
      c.style.transform = 'translateX(' + (dir * 130) + '%) rotate(' + (dir * 16) + 'deg)';
      c.style.opacity = '0'; c.style.pointerEvents = 'none';
      if (dir > 0) like(c);
      hist.push(i); i++; setTimeout(lay, 20);
    }
    w.addEventListener('click', function(e){
      var a = e.target.closest('[data-sw]'); if (!a) return;
      var k = a.getAttribute('data-sw');
      if (k === 'no') out(-1);
      else if (k === 'yes') out(1);
      else if (k === 'undo'){ if (hist.length){ i = hist.pop(); lay(); } }
      else if (k === 'bag'){ if (cards[i]) qa(cards[i]); }
      else if (k === 'reset'){ i = 0; hist = []; lay(); }
    });
    var sx = 0, dx = 0, drag = null;
    w.addEventListener('pointerdown', function(e){
      var c = e.target.closest('[data-sw-card]'); if (!c || c !== cards[i]) return;
      drag = c; sx = e.clientX; dx = 0; c.style.transition = 'none';
      if (c.setPointerCapture) c.setPointerCapture(e.pointerId);
    });
    w.addEventListener('pointermove', function(e){
      if (!drag) return; dx = e.clientX - sx;
      drag.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 18) + 'deg)';
      w.setAttribute('data-dir', dx > 40 ? 'yes' : (dx < -40 ? 'no' : ''));
    });
    function end(){
      if (!drag) return; var c = drag; drag = null; w.removeAttribute('data-dir');
      if (Math.abs(dx) > 90){ out(dx > 0 ? 1 : -1); return; }
      c.style.transition = 'transform .25s ease'; c.style.transform = 'none';
      if (Math.abs(dx) < 6){ var u = c.getAttribute('data-url'); if (u) location.href = u; }
    }
    w.addEventListener('pointerup', end); w.addEventListener('pointercancel', end);
    lay();
  }

  function init(){
    document.querySelectorAll('[data-cl-track]').forEach(setup);
    document.querySelectorAll('[data-cl-swipe]').forEach(swipe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', function(){ document.querySelectorAll('[data-cl-track]').forEach(function(t){ if (t._cl) t._cl.build(); }); });
  var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(function(){ document.querySelectorAll('[data-cl-track]').forEach(function(t){ if (t._cl) t._cl.build(); }); }, 150); });
})();
